import * as Phaser from 'phaser';

export class TransitionManager {
  private static instance: TransitionManager;
  private isTransitioning = false;

  static getInstance(): TransitionManager {
    if (!TransitionManager.instance) {
      TransitionManager.instance = new TransitionManager();
    }
    return TransitionManager.instance;
  }

  setScene(_scene: Phaser.Scene): void {
    // reserved for future transition state tracking
  }

  go(scene: Phaser.Scene, targetScene: string, data?: object, duration = 300): void {
    if (this.isTransitioning) return;
    this.isTransitioning = true;

    const overlay = scene.add.rectangle(640, 360, 1280, 720, 0xffffff, 0);
    overlay.setDepth(1000);

    scene.tweens.add({
      targets: overlay,
      alpha: 1,
      duration,
      ease: 'Quad.easeInOut',
      onComplete: () => {
        scene.scene.start(targetScene, data);
        scene.scene.bringToTop(targetScene);
        this.isTransitioning = false;
      },
    });
  }

  fadeIn(scene: Phaser.Scene, duration = 400): void {
    const overlay = scene.add.rectangle(640, 360, 1280, 720, 0xffffff, 1);
    overlay.setDepth(1000);

    scene.tweens.add({
      targets: overlay,
      alpha: 0,
      duration,
      ease: 'Quad.easeInOut',
      onComplete: () => overlay.destroy(),
    });
  }

  slideIn(scene: Phaser.Scene, direction: 'left' | 'right' | 'up' | 'down' = 'right', duration = 400): void {
    const offsets: Record<string, { x: number; y: number }> = {
      left: { x: -1280, y: 0 },
      right: { x: 1280, y: 0 },
      up: { x: 0, y: -720 },
      down: { x: 0, y: 720 },
    };

    const offset = offsets[direction];
    const overlay = scene.add.rectangle(640 + offset.x, 360 + offset.y, 1280, 720, 0xffffff, 0.9);
    overlay.setDepth(1000);

    scene.tweens.add({
      targets: overlay,
      x: 640,
      y: 360,
      alpha: 0,
      duration,
      ease: 'Back.easeOut',
      onComplete: () => overlay.destroy(),
    });
  }
}

export const transitionManager = TransitionManager.getInstance();
